<template>
  <div class="messages">
    <h1 class="messages__title page-title">Messages</h1>

    <p>
      Start a new conversation on another user's profile
    </p>

    <div class="row">
      <div class="col col-xs-12 col-md-4">
        <div class="messages__dialog-list card">
          <div
            v-for="(dialog, index) in dialogArray"
            :key="dialog.user.userId"
            :class="[
              'messages__dialog',
              {
                'messages__dialog--active': activeDialog
                  ? dialog.user.userId === activeDialog.user.userId
                  : false,
              },
            ]"
          >
            <div
              class="messages__dialog-preview"
              @click="setActiveDialog(dialog)"
            >
              <el-avatar class="messages__dialog-user-avatar" :size="46">
                <user-avatar :userId="dialog.user.userId" :alt="dialog.user.firstName + ' ' + dialog.user.lastName" />
              </el-avatar>

              <div class="message__dialog-content">
                <span class="messages__dialog-user-name">
                  {{ dialog.user.firstName + ' ' + dialog.user.lastName }}
                </span>

                <div
                  class="messages__dialog-date"
                  v-if="dialog.lastMessageDate"
                >
                  {{
                    formatDateTime(
                      dialog.lastMessageDate,
                      SHORT_DATETIME_FORMAT,
                    )
                  }}
                </div>
              </div>
            </div>

            <el-divider v-if="index < dialogArray.length - 1" />
          </div>

          <div
            class="messages__empty-dialog-list-text"
            v-if="dialogArray.length === 0"
          >
            No conversations
          </div>
        </div>
      </div>

      <div class="col col-xs-12 col-md-8">
        <div class="messages__active-dialog" v-if="activeDialog">
          <active-dialog :user-data="activeDialog.user" />
        </div>

        <div class="messages__dialog-empty card" v-else>
          Click on a conversation to see messages
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDialogs, getMessageFromUser } from '@/api/messages.js';
import ActiveDialog from '@/components/messages/ActiveDialog.vue';
import { SHORT_DATETIME_FORMAT, formatDateTime } from '@/utils/index.js';
import UserAvatar from '@/components/profile/UserAvatar.vue';

export default {
  components: { 
    ActiveDialog,
    UserAvatar,
  },
  name: 'Messages',
  data() {
    return {
      dialogArray: [],
      activeDialog: null,
      SHORT_DATETIME_FORMAT,
    };
  },
  methods: {
    formatDateTime,
    async fetchUserDialogs() {
      const { data, success } = await getDialogs();

      if (success) {
        this.dialogArray = data.items;
      }
    },
    setActiveDialog(dialog) {
      this.activeDialog = dialog;
    },
  },
  created() {
    this.fetchUserDialogs();
  },
};
</script>

<style lang="scss">
.messages {
  $this: &;

  &__title {
    margin: 0;
    margin-bottom: var(--global-dimension-size-250);

    font-weight: 500;
    font-size: var(--font-size-800);
    line-height: 1.6;
  }
  &__dialog-list {
  }
  &__dialog {
    &:hover,
    &--active {
      #{$this}__dialog-preview {
        color: var(--color-primary-400);
      }
      #{$this}__dialog-date {
        color: var(--color-primary-400);
      }
    }
  }

  &__dialog-preview {
    display: flex;
    cursor: pointer;
  }

  &__dialog-user-avatar {
    margin-right: var(--global-dimension-size-125);
  }

  &__dialog-content {
  }
  &__dialog-user-name {
  }
  &__dialog-date {
    font-size: var(--font-size-100);
    line-height: 1;
    color: var(--color-gray-800);
  }
  &__empty-dialog-list-text {
  }
  &__active-dialog {
  }
  &__dialog-empty {
  }
}
</style>
